<template>
  <div class="event-thumbnail">
    <v-img v-if="thumbnailImageUrl" :src="thumbnailImageUrl" :aspect-ratio="1" cover />
    <div v-else class="d-flex align-center justify-center fill-height background-post-detail-15">
      <i-custom-calendar class="color-post-detail" :class="{ 'size-6': compact, 'size-12': !compact }" />
    </div>
    <v-chip
      v-if="event.online_only && !compact"
      size="x-small"
      class="background-post-detail color-post-background font-size-small font-weight-bold rounded-app px-1"
    >
      <div class="d-flex align-center">
        <i-custom-camera-movie class="mr-2" />
        <div>{{ $translate("EventThumbnail.online") }}</div>
      </div>
    </v-chip>
  </div>
</template>

<script>
import * as images from "@/services/images"

export default {
  props: {
    event: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      default: 126
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    thumbnailImageUrl() {
      const image = this.event.images[0]
      if (!image) {
        return null
      }

      return images.getBestImageVersion(image, { type: "width", minWidth: 300 }).url
    },
    sizePx() {
      return `${this.size}px`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/commons.scss";

$thumbnail-size: v-bind(sizePx);

.event-thumbnail {
  min-width: $thumbnail-size !important;
  height: $thumbnail-size !important;
  width: $thumbnail-size !important;
  border-radius: var(--rounded-app);
  overflow: hidden;
  position: relative;

  .v-chip {
    position: absolute;
    top: 4px;
    left: 4px;
  }
}
</style>
